/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Questionnaire_Canclosepage2Inputs */

const en_questionnaire_canclosepage2 = /** @type {(inputs: Questionnaire_Canclosepage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You can now close this page.`)
};

const fr_questionnaire_canclosepage2 = /** @type {(inputs: Questionnaire_Canclosepage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vous pouvez maintenant fermer cette page.`)
};

/**
* | output |
* | --- |
* | "You can now close this page." |
*
* @param {Questionnaire_Canclosepage2Inputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
const questionnaire_canclosepage2 = /** @type {((inputs?: Questionnaire_Canclosepage2Inputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Questionnaire_Canclosepage2Inputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_questionnaire_canclosepage2(inputs)
	return fr_questionnaire_canclosepage2(inputs)
});
export { questionnaire_canclosepage2 as "questionnaire_canClosePage" }